// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type UpdateMasterInvoiceMutationVariables = Types.Exact<{
  linkedReceiptIds: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
  upsertInvoiceDTO: Types.UpsertInvoiceDtoInput;
}>;


export type UpdateMasterInvoiceMutationResult = { __typename?: 'Mutation', updateMasterInvoice: boolean };

export const UpdateMasterInvoiceGql = gql`
    mutation UpdateMasterInvoice($linkedReceiptIds: [Int!]!, $upsertInvoiceDTO: UpsertInvoiceDTOInput!) {
  updateMasterInvoice(
    linkedReceiptIds: $linkedReceiptIds
    upsertInvoiceDTO: $upsertInvoiceDTO
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMasterInvoiceInjectable extends Apollo.Mutation<UpdateMasterInvoiceMutationResult, UpdateMasterInvoiceMutationVariables> {
    override document = UpdateMasterInvoiceGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */